module.exports = __webpack_public_path__ + "img/dr_bg.c104b3de.png";